'use client';

import styled from 'styled-components';

const GetMuramoneyStyle = styled.div`
	--distanceTitleDescription: var(--sp4x);

	.wrapper-cashback {
		display: flex;
		flex-direction: column;
		gap: var(--distanceTitleDescription);
		justify-content: center;
	}

	.wrapper-muramoney-animation {
		-webkit-filter: brightness(1.2) contrast(20);
		background: var(--backgroundColor);
		overflow: hidden;
	}
	.lottie-muramoney {
		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			width: 90% !important;
			height: 70%;
		}
	}

	.father-div {
		width: 50%;
		height: 500px;
		margin: 0 auto;
		background-color: var(--backgroundColor);
		padding-left: 40%;
		-webkit-filter: blur(20px);
	}

	.cat {
		/* background-color: var(--mainColor); */
		width: 150px;
		height: 150px;

		border-radius: 250px;
		-webkit-animation: righty 10s infinite;
	}

	.dog {
		/* background-color: var(--mainColor); */
		width: 150px;
		height: 150px;

		border-radius: 250px;
		-webkit-animation: lefty 10s infinite;
		position: relative;
		z-index: 4;
	}

	.cat,
	.dog {
		/* background-image: url('/images/default-test/1.png');
		background-size: 100% 100%; */
		position: relative;
		overflow: hidden;
		background-color: white;

		&:before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;

			/* background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%), linear-gradient(90deg, #b700e6 -4.75%, #ff0086 83.99%); */
		}
	}

	@keyframes righty {
		0%,
		100% {
			margin-left: 100px;
		}
		50% {
			margin-left: -100px;
		}
	}

	@keyframes lefty {
		0%,
		100% {
			margin-left: -250px;
		}
		50% {
			margin-left: -50px;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleDescription: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleDescription: var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceTitleDescription: var(--sp3x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceTitleDescription: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default GetMuramoneyStyle;
